import React from "react";
import { useSelector } from "react-redux";
import { selectFormulaById } from "reducers/formulasSlice";
import {
	makeSelectSumByFormulaId,
	selectAllAnswers,
	selectAllWorkflows,
} from "reducers";
import Approval from "../approval";
import {
	selectFacilityRcs,
	selectMentalHealthRcs,
} from "./assetRc/assetRcSlice";
import {
	APPROVAL_ITIS_MAJOR_CATEGORY,
	APPROVAL_ITIS_FPIM_SETUP_TYPE,
	APPROVAL_RC_QUESTION_ID,
	FPIM_SETUP_TYPE_QUESTION_ID,
	COST_THRESHOLD_FOR_APPROVAL_ESCALATION,
	MAJOR_CATEGORY_QUESTION_ID,
	CAPITAL_ACCOUNTANT_ROLE_ID,
	FINANCE_LEAD_ROLE_ID,
	SOURCE_PROJECT_QUESTION_ID,
	MANAGEMENT_RESERVE_SOURCE_PROJECT,
} from "./constants";

function checkAnswerExistsForQuestion(answers, questionId, searchValue) {
	return answers.some((a) => {
		const value = a.value || "";
		return a.questionId === questionId && value.includes(searchValue);
	});
}

const CapexApproval = () => {
	//for validity of capex approvals
	const workflows = useSelector(selectAllWorkflows);
	const capitalAccoutant = workflows.find(
		(w) => w.roleId?.toUpperCase() === CAPITAL_ACCOUNTANT_ROLE_ID && w.user
	);
	const financeLead = workflows.find(
		(w) => w.roleId?.toUpperCase() === FINANCE_LEAD_ROLE_ID && w.user
	);

	//only valid if both these roles have been appointed users
	let isValid = true;
	let validationMessage = null;

	if (capitalAccoutant === undefined || financeLead === undefined) {
		isValid = false;
		validationMessage = `Please ensure that the "Capital Accountant" and "Finance Lead" roles are approvers for this form`;
	}

	const answers = useSelector(selectAllAnswers);
	const organisationHierarchyId = answers
		.find((a) => a.questionId === APPROVAL_RC_QUESTION_ID)
		?.value.toLowerCase();
	let conditions = [];
	const mentalHealthRcs = useSelector(selectMentalHealthRcs);
	const facilityRcs = useSelector(selectFacilityRcs);
	const selector = makeSelectSumByFormulaId("formulaId");
	const totalCost = useSelector(selector);

	const isProject = useSelector(
		(state) => selectFormulaById(state, "isProject")?.value
	);

	const isItDevice = useSelector(
		(state) => selectFormulaById(state, "isItDevice")?.value
	);

	if (!isProject) conditions.push("NotProject");

	if (!isItDevice) conditions.push("NotItDevice");

	if (mentalHealthRcs.some((rc) => rc.id.toLowerCase() === 1))
		conditions.push("MentalHealth");
	else if (
		facilityRcs.some(
			(rc) => rc.id.toLowerCase() === organisationHierarchyId
		)
	)
		conditions.push("Facilities");
	else conditions.push("NotMentalHealthOrFacilities");

	if (
		//major category includes IT IS
		checkAnswerExistsForQuestion(
			answers,
			MAJOR_CATEGORY_QUESTION_ID,
			APPROVAL_ITIS_MAJOR_CATEGORY
		) ||
		//or FPIM setup type is IT IS
		answers.find(
			(a) =>
				a.value === APPROVAL_ITIS_FPIM_SETUP_TYPE &&
				a.questionId === FPIM_SETUP_TYPE_QUESTION_ID
		)
	)
		conditions.push("ITIS");

	if (
		checkAnswerExistsForQuestion(
			answers,
			SOURCE_PROJECT_QUESTION_ID,
			MANAGEMENT_RESERVE_SOURCE_PROJECT
		)
	) {
		conditions.push("ManagementResourceSourceProject");
	}

	//cost-based conditions
	if (totalCost > COST_THRESHOLD_FOR_APPROVAL_ESCALATION)
		conditions.push("OverThreshold");
	else conditions.push("UnderThreshold");

	return (
		<>
			<Approval
				templateCode={"CapexPurchase"}
				domain="Test"
				organisationHierarchyId={organisationHierarchyId}
				options={{
					display: "role",
					enableReset: true,
					size: "large",
					enableAdd: true,
				}}
				conditions={conditions}
				isValid={isValid}
				validationMessage={validationMessage}
			/>
		</>
	);
};

export default CapexApproval;
